import values from 'lodash/values';
import extend from 'lodash/extend';
import keyBy from 'lodash/keyBy';
import forOwn from 'lodash/forOwn';
import isDate from 'lodash/isDate';
import snakeCase from 'lodash/snakeCase';
import camelCase from 'lodash/camelCase';

/**
 * Merges 2 arrays with an attempt to keep previous items if they are available in new list
 * @param list {Array<Object>} list that should be reused as max as possible
 * @param newList {Array<Object>} list that will be used for new item and to remove removed
 * @param key {string} key to differentiate maps
 * @returns new collection
 */
export function leftJoin(list, newList, key) {
  key = key || 'id';

  const map = keyBy(list, key);
  const newMap = keyBy(newList, key);

  const fullMap = extend({}, newMap, map);

  forOwn(fullMap, function (group, id) {
    if (!newMap[id]) {
      delete fullMap[id];
    }
  });

  return values(fullMap);
}

/**
 * Keys whose values are passed through untouched: their own keys are data, not field names
 * (the web shop theme keys element classes such as `ws-product-card__title` or `ws-product-card@md`).
 */
const RAW_VALUE_KEYS = ['json_theme', 'jsonTheme'];

export function formatData(data: any, transformer) {
  if (typeof data === 'object' && data !== null) {
    if (data.constructor === Array) {
      return data.map((item) => formatData(item, transformer));
    }

    let result = {};
    forOwn(data, (value, key) => {
      let transformedValue = value;
      if (typeof value === 'object' && !isDate(value) && value !== null && !RAW_VALUE_KEYS.includes(key)) {
        transformedValue = formatData(value, transformer);
      }

      let newKey = transformer(key);

      if (newKey.indexOf('f_82') >= 0) {
        newKey = newKey.replace('f_82', 'f82');
      }

      result[newKey] = transformedValue;
    });

    return result;
  } else {
    return data;
  }
}

export function snakeDataKey(data: any) {
  return formatData(data, snakeCase);
}

export function camelDataKeys(data: any) {
  return formatData(data, camelCase);
}

export const dataHelper = {
  camelDataKeys,
  snakeDataKey,
  formatData,
  leftJoin
};
